@if (apiLoaded$ | async) {
    @if (googleMapsOptions$ | async; as mapOptions) {
        <google-map
            #googleMap
            mapId="recordsMap"
            [options]="mapOptions"
            [width]="'100%'"
            [height]="'100%'"
        >
            @if (markers$ | async; as markers) {
                <map-marker-clusterer (clusterClick)="onClusterClick($event, markers)">
                    @for (marker of markers; track marker.id) {
                        <map-advanced-marker
                            #markerRef2="mapAdvancedMarker"
                            [id]="'map-marker'"
                            [position]="marker.position"
                            [title]="marker.id"
                            (mapClick)="openInfo(markerRef2, marker)"
                        >
                        </map-advanced-marker>
                    }
                </map-marker-clusterer>
                <map-info-window #infoWindow>
                    <ng-container *ngTemplateOutlet="itemDetail"> </ng-container>
                </map-info-window>
            }
        </google-map>
    }
}

<ng-template #itemDetail>
    @if (infoContent) {
        <figure class="sh-media-card--inline" style="box-shadow: none; min-width: 350px">
            <div class="sh-contained-media sh-media-card__media">
                <img [src]="infoContent.imgSrc" [alt]="infoContent.title" class="sh-contained-media__media--cover -sh-rounded" />
            </div>
            <figcaption class="sh-media-card__info">
                <a [shNavigationLink]="infoContent.navigationLink" class="sh-list-row-title sh-media-card__info__section sh-media-card__info__title">
                    {{ infoContent.title }}
                </a>
                <address class="sh-media-card__info__section sh-media-card__info__content" style="padding-bottom: 8px">
                    <p style="margin-top: 0px; margin-bottom: 8px">{{ infoContent.address }}</p>

                    <div class="sh-action-bar">
                        <div class="sh-action-bar__group">
                            @if (infoContent.actionGroup) {
                                <sh-action-group [actionGroup]="infoContent.actionGroup"></sh-action-group>
                            }
                        </div>
                    </div>
                </address>
            </figcaption>
        </figure>
    }
</ng-template>
